var pomlo_app = {};

// Define constants
pomlo_app.BREAKPOINTS = {
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1140
};
pomlo_app.DEFAULT_DURATION = 300;
pomlo_app.SMALL_HEADER_HEIGHT = 90;
pomlo_app.HEADER_HEIGHT = 105;

pomlo_app.toggleHeaderStyle = () => {
  function setSmallHeader() {
    jQuery('#navbar-container').addClass('navbar-container--small');
  }

  function unsetSmallHeader() {
    jQuery('#navbar-container').removeClass('navbar-container--small');
  }

  if ((jQuery(window).scrollTop() > pomlo_app.HEADER_HEIGHT)) {
    setSmallHeader();
  } else {
    unsetSmallHeader();
  }

};

jQuery(document).ready(function($) {
  if(jQuery("#trust-splide").length > 0){
    new Splide('#trust-splide', {
      gap: 10,
      rewind: true,
      autoplay: true,
      interval: 3000,
      pagination: false,
      isNavigation: true,
      perPage: 6,
      arrows: false,
      breakpoints: {
        1200: {
          perPage: 4,
        },
        992: {
          perPage: 2,
        },
      },
    }).mount();
  }

  pomlo_app.toggleHeaderStyle();

  jQuery('.scroll-link').click(function(e) {
    e.preventDefault();
    var target = jQuery(this).attr('href');
    if(jQuery("#navbar-container__mobile").hasClass('active')){
      jQuery("#navbar-container__mobile").removeClass('active');
      jQuery('body').removeClass('overflow-hidden');
    }
    var padding = jQuery(window).width() >= pomlo_app.BREAKPOINTS.LG ? pomlo_app.HEADER_HEIGHT : pomlo_app.SMALL_HEADER_HEIGHT;
    jQuery(target).animatescroll(
      {
        padding,
        scrollSpeed: 800,
        easing: 'swing'
      }
    );
  });

  if (document.getElementById('map') && pomloData.mapBoxToken) {
    mapboxgl.accessToken = pomloData.mapBoxToken;
    pomlo_app.map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v12',
      zoom: 9,
      center: [1.888334, 46.603354]
    });

    const bounds = new mapboxgl.LngLatBounds();

    if (pomloData.addresses && pomloData.addresses.length > 0) {

      for (let i = 0; i < pomloData.addresses.length; i++) {
        var address = pomloData.addresses[i];

        if(address.long === "" && address.lat === ""){
          continue;
        }

        const markerDiv = document.createElement('div');
        markerDiv.className = 'marker';

        var popup = new mapboxgl.Popup({className: 'popup'})
          .setLngLat([address.long, address.lat])
          .setHTML(`<strong>${address.title}</strong></br>${address.street}</br>${address.zip} ${address.city}, France`)
          .setMaxWidth("320px");

        var marker = new mapboxgl.Marker(markerDiv)
          .setLngLat([address.long, address.lat])
          .setPopup(popup)
          .addTo(pomlo_app.map);

        bounds.extend([address.long, address.lat]);
      }

    }

    pomlo_app.map.fitBounds(bounds, {
      padding: { top: 50, bottom: 50, left: 50, right: 50 },
      scrollIntoView: false
    });

    var nav = new mapboxgl.NavigationControl();
    pomlo_app.map.addControl(nav, 'bottom-right');
    pomlo_app.map.scrollZoom.disable();
  }

  jQuery('#navbar-container__toggler--open, #navbar-container__toggler--close').click(() => {
    jQuery('#navbar-container__mobile').toggleClass('active');
    if (jQuery('#navbar-container__mobile').hasClass('active')) {
      jQuery('body').addClass('overflow-hidden');
    } else {
      jQuery('body').removeClass('overflow-hidden');
    }
  });

  window.pomloUIBlock.setBlockHeight("#expertises");

});

jQuery(window).scroll(_.debounce(function() {
  pomlo_app.toggleHeaderStyle();
}, 5));

jQuery(window).resize(_.debounce(function() {
  if (jQuery(window).width() >= pomlo_app.BREAKPOINTS.LG) {
    jQuery('#navbar-container__mobile').removeClass('active');
  }
  pomlo_app.toggleHeaderStyle();
  window.pomloUIBlock.setBlockHeight("#expertises");
}, 5));
